<script lang="ts">
import { ref } from 'vue';

import PhxsgDomContent from './phxsg-dom-content.vue';

import type { PhxsgTabsLayout, PhxsgTabsOrientation, PhxsgTabsPanelData } from './tabs.types';

export interface PhxsgTabPanelProps {
  instanceId: string;
  panel: PhxsgTabsPanelData;
  orientation?: PhxsgTabsOrientation;
  layout: PhxsgTabsLayout;
}
</script>

<script setup lang="ts">
defineProps<PhxsgTabPanelProps>();

const tabElement = ref<HTMLElement | null>(null);

defineExpose({ tabElement });
</script>

<template>
  <div
    :id="`${instanceId}-tab-${panel.id}`"
    ref="tabElement"
    role="tabpanel"
    tabindex="0"
    :aria-labelledby="`${instanceId}-${panel.id}-tab-button`"
    v-bind="panel.attributes"
    :class="panel.className"
  >
    <PhxsgDomContent :nodes="panel.nodes" />
  </div>
</template>
